<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11q8nwM/tc-custom/9780795351716.jpg?1703331380219" alt="This image is the cover for the book Titan, The Trilogy of Desire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Titan, The Trilogy of Desire
      </h1>
      <p class="bookDescription body article font2">
        <b>A businessman leaves prison and heads to Chicago to regain his fortune—but his past follows close behind him—in this absorbing historical epic. </b><br/>  <br/> Newly released from prison, Frank Cowperwood immediately dives back into the stock market after the Panic of 1873, aiming to recover his lost fortune and become a millionaire once more. This time, he has a new plan and sets out for Chicago with his mistress, Aileen.<br/>  <br/> Using his brutal business sense to snuff out his opponents, Frank has his eyes on the city’s street-railway system as his ticket back to the top. But as Frank knows, the past cannot remain buried forever, and it’s only a matter of time before his previous misdeeds come back to find him in his new home, threatening his stability—and more importantly, his money.<br/>  <br/> “The great American novelist.”—<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Theodore Dreiser
      </h2>
      
      <p class="authorDescription body article">The Indiana-born Dreiser (1871-1945) has never cut a dashing or romantic swath through American literature. He has no Pulitzer or Nobel Prize to signify his importance. Yet he remains for myriad reasons: his novels are often larger than life, rugged, and defy the norms of conventional morality and organized religion. They are unapologetic in their sexual candor--in fact, outrightly frank--and challenge even modern readers. The brooding force of Dreiser&#8217;             s writing casts a dark shadow across American letters. Here in&amp;lt;i&amp;gt;An American Tragedy&amp;lt;/i&amp;gt;, Dreiser shows us the flip side of The American Dream in a gathering storm that echoes with all of the power and force of Dostoevsky&#8217;             s &amp;lt;i&amp;gt;Crime and Punishment&amp;lt;/i&amp;gt;. Inspired by the writings of Balzac and the ideas of Spenser and Freud, Dreiser went on to become one of America&#8217;             s best naturalist writers. &amp;lt;i&amp;gt;An American Tragedy&amp;lt;/i&amp;gt; is testimony to the strength of Dreiser&#8217;             s work: it retains all of its original intensity and force.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?472e88a1